import { type EmployeeRangeValue } from '@houzy/schemas/partner-cockpit/company';
import { type RegistrationChannel } from '@houzy/schemas/partner-cockpit/onboarding';
import { createContext, useContext, type Dispatch, type SetStateAction } from 'react';

export type CompanyForm = {
    companyName: string;
    street: string;
    nr: string;
    city: string;
    postcode: string;
    website: string;
    employees: EmployeeRangeValue | '';
};

export type AccountForm = {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    password: string;
    confirmPassword: string;
};

// Documents are not held here: they upload as they are picked and are read back off the application.
export type ValidationForm = {
    uid: string;
};

export type RegistrationChannelForm = {
    channel?: RegistrationChannel;
};

export type OnboardingContextValue = {
    workCategories: ReadonlySet<string>;
    setWorkCategories: Dispatch<SetStateAction<Set<string>>>;
    regions: ReadonlySet<string>;
    setRegions: Dispatch<SetStateAction<Set<string>>>;
    account: AccountForm;
    setAccount: Dispatch<SetStateAction<AccountForm>>;
    company: CompanyForm;
    setCompany: Dispatch<SetStateAction<CompanyForm>>;
    validation: ValidationForm;
    setValidation: Dispatch<SetStateAction<ValidationForm>>;
    registrationChannel: RegistrationChannelForm;
    setRegistrationChannel: Dispatch<SetStateAction<RegistrationChannelForm>>;
};

export const OnboardingContext = createContext<OnboardingContextValue | null>(null);

export function useOnboardingState(): OnboardingContextValue {
    const ctx = useContext(OnboardingContext);
    if (!ctx) {
        throw new Error('useOnboardingState must be used inside <OnboardingProvider>');
    }
    return ctx;
}
